import React from "react";
import "../assets/css/main.css";


function ServicesComponent() {
    return (
       <section class="services-section py-5" id='services'>
        <div class="container">
            <div class="text-center mb-5 section-title">
                <h2 class="fw-bold" >Our Expert Solutions</h2>
                <p class="text-muted">Explore Cleonatech’s expert solutions to grow your digital presence.</p>
            </div>

            <div class="row g-5 justify-content-center">
                
                <div class="col-lg-4 col-md-6 col-sm-6 text-center">
                    <div class="service-icon-box">
                        <i class="fas fa-code"></i>
                    </div>
                    <p class="service-title">Web Design</p>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6 text-center">
                    <div class="service-icon-box">
                        <i class="fas fa-pen-nib"></i>
                    </div>
                    <p class="service-title">Branding & Design</p>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6 text-center">
                    <div class="service-icon-box">
                        <i class="fas fa-video"></i>
                    </div>
                    <p class="service-title">Video Production Services</p>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6 text-center">
                    <div class="service-icon-box">
                        <i class="fas fa-chart-bar"></i>
                    </div>
                    <p class="service-title">Search Engine Optimization (SEO)</p>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6 text-center">
                    <div class="service-icon-box">
                        <i class="fas fa-mobile-alt"></i>
                    </div>
                    <p class="service-title">Social Media Marketing</p>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6 text-center">
                    <div class="service-icon-box">
                        <i class="fas fa-chess-knight"></i>
                    </div>
                    <p class="service-title">Strategic Marketing</p>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6 text-center">
                    <div class="service-icon-box">
                        <i class="fas fa-star"></i>
                    </div>
                    <p class="service-title">Reputation Management</p>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6 text-center">
                    <div class="service-icon-box">
                        <i class="fas fa-car"></i>
                    </div>
                    <p class="service-title">Billboard Advertising</p>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6 text-center">
                    <div class="service-icon-box">
                        <i class="fas fa-dollar-sign"></i>
                    </div>
                    <p class="service-title">Digital Marketing</p>
                </div>
            </div>
        </div>
    </section>
    );
  }
  
  export default ServicesComponent;